import '../layouts/ansysoft.css'
import coin from '../assets/prometa-coin.webp';

function Footer() {


    return (
        <>
            <div className="prometa-footer">
                <img src={coin} alt="Prometa Coin" width="148" height="148"/>
                    <p className="footer-text">2024 Copyrights &copy; Prometa. All Rights Reserved.</p>
            </div>
        </>
    )
}

export default Footer;